import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage, intlShape, injectIntl } from '../../../util/reactIntl';
import { Modal, Button, SecondaryButton } from '../..';

import css from './UpdateReceiverModal.css';

const UpdateReceiverModal = props => {
  const {
    className,
    rootClassName,
    id,
    intl,
    isOpen,
    onCloseModal,
    onManageDisableScrolling,
    onSubmit,
    initialReceiverName,
    isCustomer
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const updateReceiverInProgress = useSelector(state => state.TransactionPage.updateReceiverInProgress);

  const [receiverName, setReceiverName] = useState(initialReceiverName || '');
  const [receiverReason, setReceiverReason] = useState('');

  // Gdy otwierasz modal - resetuj stan
  useEffect(() => {
    if (isOpen) {
      setReceiverName(initialReceiverName || '');
      setReceiverReason('');
    }
  }, [isOpen, initialReceiverName]);

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      closeButtonMessage={' '}
    >
      <p className={css.modalTitle}>
        <FormattedMessage id="UpdateReceiverModal.title" defaultMessage="Zmień odbiorcę" />
      </p>

      <div className={css.modalField}>
        <label>
          <FormattedMessage id="UpdateReceiverModal.receiverName" defaultMessage="Odbierający" />
        </label>
        <input
          type="text"
          value={receiverName}
          onChange={e => setReceiverName(e.target.value)}
          placeholder={intl.formatMessage({ id: 'UpdateReceiverModal.receiverPlaceholder', defaultMessage: 'Imię i nazwisko odbierającego' })}
        />
      </div>

      {!isCustomer &&
        <div className={css.modalField}>
          <label>
            <FormattedMessage id="UpdateReceiverModal.reason" defaultMessage="Powód zmiany (opcjonalny)" />
          </label>
          <textarea
            value={receiverReason}
            onChange={e => setReceiverReason(e.target.value)}
            placeholder={intl.formatMessage({ id: 'UpdateReceiverModal.reasonPlaceholder', defaultMessage: 'Dlaczego zmieniasz odbiorcę?' })}
          />
        </div>
      }

      <div className={css.modalButtons}>
        <Button
          onClick={() => onSubmit(receiverName, receiverReason)}
          inProgress={updateReceiverInProgress}
          disabled={!receiverName.trim() || (!receiverReason && !isCustomer) || updateReceiverInProgress}
        >
          <FormattedMessage id="UpdateReceiverModal.save" defaultMessage="Zapisz" />
        </Button>
        <SecondaryButton onClick={onCloseModal}>
          <FormattedMessage id="UpdateReceiverModal.cancel" defaultMessage="Anuluj" />
        </SecondaryButton>
      </div>
    </Modal>
  );
};

const { bool, string, func } = PropTypes;

UpdateReceiverModal.defaultProps = {
  className: null,
  rootClassName: null,
  initialReceiverName: '',
};

UpdateReceiverModal.propTypes = {
  className: string,
  rootClassName: string,
  id: string.isRequired,
  intl: intlShape.isRequired,
  isOpen: bool.isRequired,
  onCloseModal: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  onSubmit: func.isRequired,
  initialReceiverName: string,
};

export default injectIntl(UpdateReceiverModal);
